import React, { PureComponent } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsCustomEvents from "highcharts-custom-events";
import { hashCode, intToRGB, kmFormatter } from "../utils";
import { MetricsList } from "../../../AdvancedCustomChart/MetricsList";
import { connect } from "react-redux";
// import { numberWithCommas } from "../utils";
import HC_brokenAxis from "highcharts/modules/broken-axis";
import { numberWithCommas, convertToTitleCase } from "../utils";
// import { numberWithCommas, kmFormatter, intToRGB, hashCode } from "../utils";
import moment from "moment-timezone";
// import UpIcon from "../../../../../assets/svg/percentage_arrow.svg";
// import DownIcon from "../../../../../assets/svg/arrow-down.svg";
HC_brokenAxis(Highcharts);
HighchartsCustomEvents(Highcharts);
class AdvanceCustomChartDisplay extends PureComponent {
    constructor(props) {
        super(props);
        this.chartComponent = React.createRef();
    }
    // componentDidUpdate(prevProps) {
    //     if (this.props !== prevProps) {
    //
    //         // this.chartComponent?.current=null
    //         //  this.props.data.forEach((seriesElement) => this.chartComponent?.current?.chart.addSeries(seriesElement, false));
    //         // //   this.chartComponent?.current?.chart.addSeries();
    //         // this.chartComponent?.current?.chart.redraw();
    //         // this.chartComponent?.current?.chart.render();
    //     }
    // }
    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 100);
        });

        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        // this.chartComponent?.current?.chart.destroy();
        // this.props.data.forEach((seriesElement) => this.chartComponent?.current?.chart.addSeries(seriesElement, false));
        // this.chartComponent?.current?.chart.redraw();
        // this.chartComponent?.current = null;

        this.ro.disconnect();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (
            nextProps.expandWidget !== this.props.expandWidget ||
            nextProps.showLegend !== this.props.showLegend ||
            nextProps.showLabel !== this.props.showLabel ||
            nextProps.currentChartType !== this.props.currentChartType ||
            nextProps.showGridLines !== this.props.showGridLines
        ) {
            return true;
        }

        return false;
    }

    getTwoDimensionTwoMetricBarOptions = () => {
        let redrawingEnabled = true;

        const adjustLegendHeight = (chart) => {
            chart.legend.update({
                maxHeight: chart.chartHeight / 4,
            });
        };

        const sortedData = (chartSource) => {
            var series = chartSource.series;
            // var axis = chartSource.xAxis[0];
            var categories = [];

            const countryCounts = {};
            if (series[0]?.data) {
                if (series)
                    series.forEach((obj) => {
                        obj.stack === "common" &&
                            obj.data.forEach((item) => {
                                const country = item.name;
                                const count = item.y;

                                if (countryCounts[country]) {
                                    countryCounts[country] += count;
                                } else {
                                    countryCounts[country] = count;
                                }
                            });
                    });

                const countryCountArray = Object.entries(countryCounts).map(([name, count]) => ({ name, count }));

                if (Array.isArray(series)) {
                    var ser = series.find(function (ser) {
                        return ser;
                    });

                    ser.data.forEach(function (datum) {
                        var obj = {
                            name: datum.name,
                            index: ser.data.indexOf(datum),
                            stackTotal: countryCountArray.filter((ele) => ele.name == datum.name)[0].count,
                            breakDownId: datum.breakDownId,
                            breakdownDimensionName: datum.breakdownDimensionName,
                            // color: datum.color,
                            dataId: datum.dataId,
                            dimensionName: datum.dimensionName,
                            yAxisName: datum.yAxisName,
                        };
                        categories.push(obj);
                    });
                }

                categories.sort(function (a, b) {
                    var aName = a.name.toLowerCase();
                    var bName = b.name.toLowerCase();
                    var aTotal = a.stackTotal;
                    var bTotal = b.stackTotal;
                    if (aTotal === bTotal) {
                        return aName < bName ? -1 : aName > bName ? 1 : 0;
                    } else {
                        return aTotal > bTotal ? -1 : aTotal < bTotal ? 1 : 0;
                    }
                });

                var mappedIndex = categories.map(function (category) {
                    return category.index;
                });

                categories = categories.map(function (category) {
                    return category.name;
                });

                series.forEach(function (ser) {
                    var data = mappedIndex.map(function (mappedIndex, i) {
                        return {
                            name: ser.data[mappedIndex]?.name,
                            y: ser.data[mappedIndex]?.y || 0,
                            breakDownId: ser.data[mappedIndex]?.breakDownId,
                            breakdownDimensionName: ser.data[mappedIndex]?.breakdownDimensionName,
                            dataId: ser.data[mappedIndex]?.dataId,
                            dimensionName: ser.data[mappedIndex]?.dimensionName,
                            yAxisName: ser.data[mappedIndex]?.yAxisName,
                            breakDownName: ser.data[mappedIndex]?.breakDownName,
                        };
                    });
                    ser.data = data;
                });

                return ser;
            }
        };
        let chartConfig = {};
        // let data = this.props.expandWidget
        //     ? this.props.data && JSON.parse(JSON.stringify(this.props.data))
        //     : this.props.data?.minimizedData && JSON.parse(JSON.stringify(this.props.data?.minimizedData));
        let data = JSON.parse(JSON.stringify(this.props.data));
        let chartData = [];

        // chartData.push(JSON.parse(JSON.stringify(data.leftYAxis.data)));
        // chartData.push(JSON.parse(JSON.stringify(data.rightYAxis.data)));

        // let total = this.props.data.total;
        let self = this;
        let YAxisLabel = MetricsList.metrics.filter((ele) => ele.label == this.props.widget.multiDimensionChartConfig.breakdownMetricName.label);
        let YAxisLabel1 = MetricsList.metrics.filter((ele) => ele.label == this.props.widget.multiDimensionChartConfig.metricName.label);
        let xAxisLabel1 = this.props.widget.multiDimensionChartConfig.dimensionName.value;
        let xAxisLabel2 = this.props.widget.multiDimensionChartConfig.breakdownDimensionName.value;
        chartData = data.leftYAxis.data.map((element, index) => [element, data.rightYAxis.data[index]]).flat();

        chartConfig = {
            chart: {
                className: "skiptranslate",
                type: "column",
                backgroundColor: "transparent", // title: "",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                events: {
                    render: function () {
                        if (redrawingEnabled) {
                            // disable redrawing to prevent infinite recursive redraw() loop (update() fires redraw by default)
                            redrawingEnabled = false;

                            adjustLegendHeight(this);

                            // enable redrawing after update and redraw are finished
                            redrawingEnabled = true;
                        }
                    },
                    load: function () {
                        Highcharts.addEvent(this.tooltip, "headerFormatter", function (e) {
                            if (!e.isFooter) {
                                e.text = `<b> ${xAxisLabel1} - ${e.labelConfig.key}</b><br/>
                <span style="border:0px solid gray;display:block;border-radius:4px;width:300px;padding:0px 1px;">
                <span style="dispaly:inline-block;margin-bottom:20px;border-right:0px solid gray;padding:3px;">
                <span style="display:inline-block;width:114px;"><b>${xAxisLabel2} </b></span></span> 
                <span style="display:inline-block;padding:1px 2px;width:42px;"><b> ${
                    e.labelConfig.point.yAxisName == "Mention" ? "Volume of Conversation" : e.labelConfig.point.yAxisName
                }</b></span>`;
                                return false; // prevent default
                            }
                            return true; // run default
                        });
                    },
                },
            },
            title: {
                text: ``,
            },
            legend: {
                enabled: this.props.showLegend,
                itemStyle: {
                    fontWeight: 500,
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                },
            },
            credits: {
                enabled: false,
            },

            xAxis: [
                {
                    type: "category",
                    // reversed: xAxisLabel1 == "Published Date" ? true : false,
                },
            ],
            yAxis: [
                {
                    // Primary yAxis
                    gridLineWidth: this.props.showGridLines ? 2 : 0,
                    gridLineDashStyle: "ShortDash",
                    gridLineColor: "#ccd6eb",
                    lineColor: "#ccd6eb",
                    lineWidth: 1,
                    title: {
                        text: YAxisLabel[0].value,
                    },

                    opposite: true,
                    stackLabels: {
                        style: {
                            color: "blue",
                        },
                        // enabled: true,
                        enabled: this.props.showLabel,
                        formatter: function () {
                            return kmFormatter(this.total);
                        },
                    },

                    // title: {
                    //     text: this.props.widget.multiDimensionChartConfig.metricName,
                    // },
                },
                {
                    // Secondary yAxis
                    gridLineWidth: this.props.showGridLines ? 2 : 0,
                    gridLineDashStyle: "ShortDash",
                    gridLineColor: "#ccd6eb",
                    lineColor: "#ccd6eb",
                    lineWidth: 1,
                    title: {
                        text: YAxisLabel1[0].value,
                    },
                    stackLabels: {
                        style: {
                            color: "blue",
                        },
                        // enabled: true,
                        enabled: this.props.showLabel,
                        formatter: function () {
                            return kmFormatter(this.total);
                        },
                    },

                    // title: {
                    //     text: this.props.widget.multiDimensionChartConfig.breakdownMetricName,
                    // },

                    // opposite: true,
                },
            ],
            plotOptions: {
                column: {
                    // grouping: false,
                    stacking: "normal",
                    // showInLegend: this.props.showLegend,
                    borderWidth: 0,
                    minPointLength: 8,
                    dataLabels: {
                        enabled: this.props.showLabel,
                        inside: true,
                        formatter: function () {
                            if (this.point.shapeArgs.height < this.point.name?.length * 2) {
                                return;
                            } else {
                                return kmFormatter(this.y);
                            }
                            // return kmFormatter(this.y);
                        },
                        style: {
                            color: "white",
                            textOutline: "none",
                            fontFamily: "'Roboto', sans-serif",
                        },
                    },

                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, Object.assign({}, this));
                            },
                        },
                    },
                },
            },
            tooltip: {
                // followPointer: true,
                // followTouchMove: true,
                // shared: true,
                backgroundColor: "#fff",
                borderColor: "#fff",
                borderRadius: 6,
                useHTML: true,
                shadow: false,
                // headerFormat: `<span style="display:block;margin-bottom:5px"><b>{point.point.main_subtopic_name}</b></span>`,
                padding: 10,
                opacity: 1,
                outside: true,
                style: {
                    zIndex: 200000,
                    opacity: 1,
                    backgroundColor: "#ff6633",
                },
                // width: 800,

                pointFormatter: function () {
                    let allSeries = this.series.chart.series;
                    let toolTipData = ``;
                    let topicTotal = this.total;

                    allSeries.forEach((ele, i) => {
                        if (this.yAxisName == ele.points[this.index]?.yAxisName) {
                            let visibleLegend = this.series.chart.legend.allItems.filter((element) => element.name == ele.points[this.index]?.breakDownName);

                            visibleLegend.forEach((e) => {
                                let reqObject = ele.points.filter((item) => item.category == this.category);
                                if (e.visible && reqObject[0]?.y != 0) {
                                    toolTipData += `<span style="border:0px solid gray;display:block;border-radius:4px;width:300px;padding:0px 1px;"><span style="dispaly:inline-block;margin-bottom:20px;border-right:0px solid gray;padding:3px;"> <span style="margin-right:4px;display:inline-block;width:8px;height:8px;background-color:${
                                        reqObject[0]?.color
                                    };border-radius:10px" ></span> <span style="display:inline-block;width:114px;">${
                                        reqObject[0]?.breakDownName
                                    } </span></span> <span style="display:inline-block;padding:1px 2px;width:42px;"> ${
                                        ((reqObject[0]?.y * 100) / topicTotal).toFixed(1) + "%"
                                    }</span> <span style="display:inline-block;padding:1px">(${numberWithCommas(reqObject[0]?.y)} / ${numberWithCommas(
                                        topicTotal,
                                    )})</span><br/> </span>`;
                                }
                            });
                        }
                    });

                    return toolTipData;
                },
            },

            series: chartData,
        };
        xAxisLabel1 !== "Published Date" && sortedData(chartConfig);
        return chartConfig;
    };

    getOneDimensionTwoMetricBarOptions = () => {
        let chartConfig = {};
        // let data = JSON.parse(JSON.stringify(this.props.data));

        let data = this.props.expandWidget
            ? this.props.maximizeData && JSON.parse(JSON.stringify(this.props.maximizeData))
            : this.props.data && JSON.parse(JSON.stringify(this.props.data));

        // let data = this.props.data && JSON.parse(JSON.stringify(this.props.data));
        let chartData = [];

        chartData.push(data.leftYAxis);
        chartData.push(data.rightYAxis);

        let xAxisLabel = this.props.widget.multiDimensionChartConfig.dimensionName.value;

        // let total = this.props.data.total;
        let self = this;

        chartConfig = {
            chart: {
                type: "column",
                className: "skiptranslate",
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            title: {
                text: ``,
            },
            credits: {
                enabled: false,
            },

            xAxis: [
                {
                    type: "category",
                },
            ],
            yAxis: [
                {
                    // Primary yAxis

                    title: {
                        text: chartData[1].name,
                    },
                    gridLineWidth: this.props.showGridLines ? 2 : 0,
                    gridLineDashStyle: "shortdash",
                    gridLineColor: "#ccd6eb",
                    lineColor: "#ccd6eb",
                    lineWidth: 1,
                    opposite: true,
                    stackLabels: {
                        style: {
                            color: "blue",
                        },
                        // enabled: true,
                        enabled: this.props.showLabel,
                        formatter: function () {
                            return kmFormatter(this.total);
                        },
                    },
                },
                {
                    // Secondary yAxis
                    title: {
                        text: chartData[0].name,
                    },
                    gridLineWidth: this.props.showGridLines ? 2 : 0,
                    gridLineDashStyle: "shortdash",
                    gridLineColor: "#ccd6eb",
                    lineColor: "#ccd6eb",
                    lineWidth: 1,
                    stackLabels: {
                        style: {
                            color: "blue",
                        },
                        // enabled: true,
                        enabled: this.props.showLabel,
                        formatter: function () {
                            return kmFormatter(this.total);
                        },
                    },
                },
            ],
            series: JSON.parse(JSON.stringify(chartData)),
            plotOptions: {
                column: {
                    // grouping: false,
                    stacking: "normal",
                    showInLegend: this.props.showLegend,
                    borderWidth: 0,
                    minPointLength: 8,
                    // dataSorting: {
                    //     enabled: true,
                    //     sortKey: 'y'
                    // },
                    dataLabels: {
                        enabled: this.props.showLabel,
                        inside: true,
                        formatter: function () {
                            if (this.point.shapeArgs.height < this.point.name?.length * 2) {
                                return;
                            } else {
                                return kmFormatter(this.y);
                            }
                            // return kmFormatter(this.y);
                        },
                        style: {
                            color: "white",
                            textOutline: "none",
                            fontFamily: "'Roboto', sans-serif",
                        },
                    },
                    // events: {},

                    // column: {
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, Object.assign({}, this));
                            },
                        },
                    },
                    // },
                },
            },
            tooltip: {
                // shared: true,
                backgroundColor: "#fff",
                borderColor: "#fff",
                borderRadius: 6,
                // followPointer: true,
                followTouchMove: true,
                useHTML: true,
                formatter: function () {
                    return `
                    <span style="display:inline-block;"><b>${xAxisLabel}</b></span><br />
                    <span style="padding:2px 0px;">${this.key}</span><br />
                    <br/>
                    <span style="display:inline-block;"><b> ${this.series.name} </b></span>
                    <br />
                    <span style="display:inline-block;">${numberWithCommas(this.y)} </span>
                    </span>`;
                },
            },
        };
        return chartConfig;
    };

    getTwoDimensionOneMetricBarOptions = () => {
        let redrawingEnabled = true;

        const adjustLegendHeight = (chart) => {
            chart.legend.update({
                maxHeight: chart.chartHeight / 4,
            });
        };
        const sortedData = (chartSource) => {
            var series = chartSource.series;
            // var axis = chartSource.xAxis[0];
            var categories = [];

            // console.log("firstchartSource", series, chartSource);
            const countryCounts = {};
            if (series[0]?.data) {
                if (series)
                    series.forEach((obj) => {
                        obj.data.forEach((item) => {
                            const country = item.name;
                            const count = item.y;

                            if (countryCounts[country]) {
                                countryCounts[country] += count;
                            } else {
                                countryCounts[country] = count;
                            }
                        });
                    });

                const countryCountArray = Object.entries(countryCounts).map(([name, count]) => ({ name, count }));

                // console.log("firstchartSource", chartSource, countryCountArray);

                if (Array.isArray(series)) {
                    var ser = series.find(function (ser) {
                        return ser;
                    });

                    ser.data.forEach(function (datum) {
                        var obj = {
                            name: datum.name,
                            index: ser.data.indexOf(datum),
                            stackTotal: countryCountArray.filter((ele) => ele.name == datum.name)[0].count,
                            breakDownId: datum.breakDownId,
                            breakdownDimensionName: datum.breakdownDimensionName,
                            // color: datum.color,
                            dataId: datum.dataId,
                            dimensionName: datum.dimensionName,
                            yAxisName: datum.yAxisName,
                        };
                        categories.push(obj);
                    });
                }

                categories.sort(function (a, b) {
                    var aName = a.name.toLowerCase();
                    var bName = b.name.toLowerCase();
                    var aTotal = a.stackTotal;
                    var bTotal = b.stackTotal;
                    if (aTotal === bTotal) {
                        return aName < bName ? -1 : aName > bName ? 1 : 0;
                    } else {
                        return aTotal > bTotal ? -1 : aTotal < bTotal ? 1 : 0;
                    }
                });

                // const breakDownId = categories.slice(function (category) {
                //     return category.breakDownId;
                // });
                // const breakdownDimensionName = categories.slice(function (category) {
                //     return category.breakdownDimensionName;
                // });
                // const color = categories.slice(function (category) {
                //     return category.color;
                // });
                // const dataId = categories.slice(function (category) {
                //     return category.dataId;
                // });
                // const dimensionName = categories.slice(function (category) {
                //     return category.dimensionName;
                // });
                // const yAxisName = categories.slice(function (category) {
                //     return category.yAxisName;
                // });

                var mappedIndex = categories.map(function (category) {
                    return category.index;
                });

                categories = categories.map(function (category) {
                    return category.name;
                });
                // console.log("serdataa", categories, series, mappedIndex);
                series.forEach(function (ser) {
                    var data = mappedIndex.map(function (mappedIndex, i) {
                        return {
                            name: ser.data[mappedIndex]?.name,
                            y: ser.data[mappedIndex]?.y || 0,
                            breakDownId: ser.data[mappedIndex]?.breakDownId,
                            breakdownDimensionName: ser.data[mappedIndex]?.breakdownDimensionName,
                            dataId: ser.data[mappedIndex]?.dataId,
                            dimensionName: ser.data[mappedIndex]?.dimensionName,
                            yAxisName: ser.data[mappedIndex]?.yAxisName,
                            breakDownName: ser.data[mappedIndex]?.breakDownName,
                        };
                    });
                    ser.data = data;
                });

                // console.log("categoriesseriesserser", series, mappedIndex, ser);

                return ser;
            }
        };

        let chartConfig = {};
        let data = this.props.data && JSON.parse(JSON.stringify(this.props.data));
        // let data = this.props.expandWidget
        //     ? this.props.data && JSON.parse(JSON.stringify(this.props.data))
        //     : (this.props.maximizeData && JSON.parse(JSON.stringify(this.props.maximizeData))) || JSON.parse(JSON.stringify(this.props.data));

        let chartData = [];

        // chartData.push(JSON.parse(JSON.stringify(data.leftYAxis.data)));
        // chartData.push(JSON.parse(JSON.stringify(data.rightYAxis.data)));

        // let total = this.props.data.total;
        chartData = data;
        // let YAxisLabel = MetricsList.metrics.filter((ele) => ele.label == this.props.advCustomChartReducer.multiDimensionChartConfig.metricName);

        let self = this;

        // chartData = [...chartData, ...data[0]];

        let xAxisLabel1 = this.props.widget.multiDimensionChartConfig.dimensionName.value;
        let xAxisLabel2 = this.props.widget.multiDimensionChartConfig.breakdownDimensionName.value;

        chartConfig = {
            chart: {
                type: "column",
                className: "skiptranslate",
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                events: {
                    render: function () {
                        if (redrawingEnabled) {
                            // disable redrawing to prevent infinite recursive redraw() loop (update() fires redraw by default)
                            redrawingEnabled = false;

                            adjustLegendHeight(this);

                            // enable redrawing after update and redraw are finished
                            redrawingEnabled = true;
                        }
                    },

                    load: function () {
                        Highcharts.addEvent(this.tooltip, "headerFormatter", function (e) {
                            if (!e.isFooter) {
                                e.text = `<b> ${xAxisLabel1} - ${e.labelConfig.key}</b><br/>
                <span style="border:0px solid gray;display:block;border-radius:4px;width:300px;padding:0px 1px;">
                <span style="dispaly:inline-block;margin-bottom:20px;border-right:0px solid gray;padding:3px;">
                <span style="display:inline-block;width:114px;"><b>${xAxisLabel2} </b></span></span> 
                <span style="display:inline-block;padding:1px 2px;width:42px;"><b> ${
                    e.labelConfig.point.yAxisName == "Mention" || e.labelConfig.point.yAxisName == "mention"
                        ? "Volume of Conversation"
                        : e.labelConfig.point.yAxisName
                }</b></span>`;
                                return false; // prevent default
                            }
                            return true; // run default
                        });
                    },
                },
            },
            title: {
                text: ``,
            },
            credits: {
                enabled: false,
            },

            xAxis: [
                {
                    type: "category",
                    reversed: xAxisLabel1 == "Published Date" ? true : false,
                },
            ],
            yAxis: [
                {
                    // Primary yAxis

                    // type: "logarithmic",
                    // custom: {
                    //     allowNegativeLog: true,
                    // },

                    gridLineWidth: this.props.showGridLines ? 2 : 0,
                    gridLineDashStyle: "ShortDash",
                    gridLineColor: "#ccd6eb",
                    lineColor: "#ccd6eb",
                    lineWidth: 1,
                    title: {
                        // text: YAxisLabel[0].value,
                        // text: chartData[0]?.yAxisName,
                        text:
                            chartData[0]?.yAxisName === "mention"
                                ? "Volume of Conversation"
                                : chartData[0]?.yAxisName === "Mention"
                                ? "Volume of Conversation"
                                : chartData[0]?.yAxisName,
                    },

                    stackLabels: {
                        style: {
                            color: "blue",
                        },
                        // enabled: true,
                        enabled: this.props.showLabel,
                        formatter: function () {
                            return kmFormatter(this.total);
                        },
                    },
                },
                // {
                //     // Secondary yAxis
                //     title: {
                //         text: "right",
                //     },

                //     opposite: true,
                // },
            ],
            plotOptions: {
                // column: {
                //     stacking: "normal",
                //     showInLegend: true,
                //     dataLabels: {
                //         enabled: true,
                //     },
                // },
                column: {
                    // grouping: false,
                    stacking: "normal",
                    showInLegend: this.props.showLegend,
                    borderWidth: 0,
                    minPointLength: 8,
                    dataSorting: {
                        enabled: xAxisLabel1 == "Published Date" ? true : false,
                        sortKey: "name",
                    },
                    dataLabels: {
                        enabled: this.props.showLabel,
                        inside: true,
                        formatter: function () {
                            // if (this.y > 0) {
                            if (this.point.shapeArgs.height < this.point.name.length * 2) {
                                return;
                            } else {
                                return kmFormatter(this.y);
                            }
                            // }
                        },
                        style: {
                            color: "white",
                            textOutline: "none",
                            fontFamily: "'Roboto', sans-serif",
                        },
                    },
                    events: {},
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, Object.assign({}, this));
                            },
                        },
                    },
                },
            },

            tooltip: {
                backgroundColor: "#fff",
                borderColor: "#fff",
                borderRadius: 6,
                useHTML: true,
                shadow: false,
                padding: 10,
                opacity: 1,
                outside: true,
                style: {
                    zIndex: 200000,
                    opacity: 1,
                    backgroundColor: "#ff6633",
                },
                // width: 800,

                pointFormatter: function () {
                    let allSeries = this.series.chart.series;
                    let toolTipData = ``;
                    let topicTotal = this.total;

                    allSeries.forEach((ele, i) => {
                        if (this.yAxisName == ele.points[this.index]?.yAxisName) {
                            let visibleLegend = this.series.chart.legend.allItems.filter((element) => element.name == ele.points[this.index]?.breakDownName);

                            visibleLegend.forEach((e) => {
                                let reqObject = ele.points.filter((item) => item.category == this.category);
                                if (e.visible && reqObject[0]?.y != 0) {
                                    toolTipData += `<span style="border:0px solid gray;display:block;border-radius:4px;width:300px;padding:0px 1px;"><span style="dispaly:inline-block;margin-bottom:20px;border-right:0px solid gray;padding:3px;"> <span style="margin-right:4px;display:inline-block;width:8px;height:8px;background-color:${
                                        reqObject[0]?.color
                                    };border-radius:10px" ></span> <span style="display:inline-block;width:114px;">${
                                        reqObject[0]?.breakDownName
                                    } </span></span> <span style="display:inline-block;padding:1px 2px;width:42px;"> ${
                                        ((reqObject[0]?.y * 100) / topicTotal).toFixed(1) + "%"
                                    }</span> <span style="display:inline-block;padding:1px">(${numberWithCommas(reqObject[0]?.y)} / ${numberWithCommas(
                                        topicTotal,
                                    )})</span><br/> </span>`;
                                }
                            });
                        }
                    });

                    return toolTipData;
                },
            },
            series: chartData,
        };
        sortedData(chartConfig);
        return chartConfig;
    };
    getOneDimensionOneMetric = () => {
        let chartConfig = {};
        let data = this.props.expandWidget
            ? this.props.maximizeData && JSON.parse(JSON.stringify(this.props.maximizeData))
            : this.props.data && JSON.parse(JSON.stringify(this.props.data));
        let chartData = [];

        chartData = data;

        let self = this;
        var breaks = new Map();
        let YAxisLabel = MetricsList.metrics.filter((ele) => ele.label == this.props.multiDimensionChartConfig.metricName);
        let xAxisLabel = this.props.widget.multiDimensionChartConfig.dimensionName.value;
        let yAxisLabel1 = this.props.widget.multiDimensionChartConfig.metricName.value;

        chartConfig = {
            chart: {
                type: "column",
                className: "skiptranslate",
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            title: {
                text: ``,
            },
            credits: {
                enabled: false,
            },

            xAxis: [
                {
                    type: "category",
                },
            ],
            yAxis: [
                {
                    // Primary yAxis

                    title: {
                        text:
                            data[0]?.metricName === "mention" || data[0]?.metricName === "Mention"
                                ? "Volume of Conversation"
                                : data[0]?.metricName
                                ? data[0]?.metricName
                                : this.props.multiDimensionChartConfig.metricName,
                    },

                    gridLineWidth: this.props.showGridLines ? 2 : 0,
                    gridLineDashStyle: "shortdash",
                    gridLineColor: "#ccd6eb",
                    lineColor: "#ccd6eb",
                    lineWidth: 1,
                    stackLabels: {
                        style: {
                            color: "blue",
                        },
                        enabled: this.props.showLabel,
                        // enabled: true,
                        formatter: function () {
                            // console.log("firsttotsl", this);
                            return kmFormatter(this.total);
                        },
                    },
                },
            ],

            series: JSON.parse(JSON.stringify(chartData)),

            plotOptions: {
                series: {
                    borderWidth: 0,
                    minPointLength: 8,
                    // stacking: "normal",
                    dataLabels: {
                        enabled: this.props.showLabel,
                        inside: true,
                        formatter: function () {
                            if (this.point.shapeArgs.height < this.point.name?.length * 2) {
                                return;
                            } else {
                                return kmFormatter(this.y);
                            }
                            // return kmFormatter(this.y);
                        },
                        style: {
                            color: "white",
                            textOutline: "none",
                        },
                    },
                    events: {
                        legendItemClick: function () {
                            if (breaks.has(this.xData[0])) {
                                breaks.delete(this.xData[0]);
                            } else {
                                breaks.set(this.xData[0], { from: this.xData[0] - 0.5, to: this.xData[0] + 0.5, breakSize: 0 });
                            }

                            this.chart.xAxis[0].update({
                                breaks: [...breaks.values()],
                            });
                        },
                    },
                },

                column: {
                    grouping: false,
                    stacking: "normal",
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, Object.assign({}, this));
                            },
                        },
                    },
                },
            },
            tooltip: {
                // shared: true,
                backgroundColor: "#fff",
                borderColor: "#fff",
                borderRadius: 6,
                followPointer: true,
                followTouchMove: true,
                useHTML: true,
                formatter: function () {
                    return `
                    <span style="display:inline-block;"><b>${xAxisLabel}</b></span><br />
                    <span style="padding:2px 0px;">${this.key}</span><br />
                    <br/>
                    <span style="display:inline-block;"><b>${yAxisLabel1} </b></span><br/>
                    <span style="padding:2px 0px;">${numberWithCommas(this.y)}</span>
                    `;
                },
            },
            legend: {
                enabled: this.props.showLegend,
                itemStyle: {
                    fontWeight: 500,
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                },
            },
        };
        return chartConfig;
    };

    getTwoDimensionOneMetricLineOptions = () => {
        let self = this;
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let tzo = JSON.parse(localStorage.company).user_timezone * -60;

        let serObj = [];
        for (const key in this.props.csvData.lineData[0].chartData) {
            if (key !== "date") {
                const obj = {
                    name: this.props.csvData.lineData[0].chartData[key]?.[0]?.breakDownName || key,
                    data: this.props.csvData.lineData[0].chartData[key],
                    color: this.props.csvData.lineData[0]?.chartData[key][0]?.color,
                };
                serObj.push(obj);
            }
        }

        const optionsOverTime = {
            chart: {
                type: "spline",
                className: "skiptranslate",
                backgroundColor: "transparent",
                // spacingTop: 0,
                // spacingBottom: 0,
                // spacingLeft: 0,
                // spacingRight: 0,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            credits: {
                enabled: false,
            },
            title: {
                text: " ",
            },
            legend: {
                enabled: this.props.showLegend,
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M %p",
                    second: "%l:%M %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
                labels: {
                    style: {
                        textTransform: "normal",
                    },
                },
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: " ",
            },
            series: serObj,
            plotOptions: {
                series: {
                    marker: {
                        symbol: "circle",
                        radius: 4,
                    },
                    stickyTracking: false,
                    // events: {
                    //     legendItemClick: function () {
                    //         self.props.legendClick(true);
                    //     },
                    // },
                    // {
                    //     symbol: "triangle-down",
                    //     radius: 4,
                    // },
                    // ],
                },
                spline: {
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, Object.assign({}, this));
                            },
                        },
                    },
                },
            },
            time: {
                timezoneOffset: tzo,
            },
            tooltip: {
                followPointer: true,
                // followTouchMove: true,
                //  shared: plotComaprisiondata ? true : false,
                // outside: true,
                // crosshairs: true,
                useHTML: true,
                formatter: function () {
                    return `${moment(this.x).tz(tz).format("LLLL")}<br/>
                    <b>${this.point?.breakdownDimensionName}</b> : ${this.point?.series?.name}<br/>
                    <b>${this.point?.yAxisName}</b>: ${numberWithCommas(this.y)}`;
                },

                backgroundColor: "#fff",
                borderRadius: 6,
            },
        };

        return optionsOverTime;
    };
    getTwoDimensionTwoMetricLineOptions = () => {
        let self = this;
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let tzo = JSON.parse(localStorage.company).user_timezone * -60;
        const leftChartData = this.props.data.leftYAxis.lineData.chartData;
        const rightChartData = this.props.data.rightYAxis.lineData.chartData;

        const serObj = [];

        const keys = Object.keys(leftChartData);

        keys.forEach((key, index) => {
            if (key !== "date") {
                const leftObj = {
                    name: leftChartData[key]?.[0]?.breakDownName || key,
                    data: leftChartData[key],
                    color: leftChartData[key]?.[0]?.color,
                    stack: "common",
                };
                serObj.push(leftObj);

                const rightObj = {
                    name: rightChartData[key]?.[0]?.breakDownName || key,
                    data: rightChartData[key],
                    color: rightChartData[key]?.[0]?.color,
                    linkedTo: ":previous",
                };
                serObj.push(rightObj);
            }
        });

        const optionsOverTime = {
            chart: {
                type: "spline",
                className: "skiptranslate",
                backgroundColor: "transparent",
                // spacingTop: 0,
                // spacingBottom: 0,
                // spacingLeft: 0,
                // spacingRight: 0,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            credits: {
                enabled: false,
            },
            title: {
                text: " ",
            },
            legend: {
                enabled: this.props.showLegend,
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M %p",
                    second: "%l:%M %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
                labels: {
                    style: {
                        textTransform: "normal",
                    },
                },
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: " ",
            },
            series: serObj,
            plotOptions: {
                series: {
                    marker: {
                        symbol: "circle",
                        radius: 4,
                    },
                    stickyTracking: false,
                    // events: {
                    //     legendItemClick: function () {
                    //         self.props.legendClick(true);
                    //     },
                    // },
                    // {
                    //     symbol: "triangle-down",
                    //     radius: 4,
                    // },
                    // ],
                },
                spline: {
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, Object.assign({}, this));
                            },
                        },
                    },
                },
            },
            time: {
                timezoneOffset: tzo,
            },
            tooltip: {
                followPointer: true,
                // followTouchMove: true,
                // shared: plotComaprisiondata ? true : false,
                // outside: true,
                // crosshairs: true,
                useHTML: true,
                formatter: function () {
                    return `${moment(this.x).tz(tz).format("LLLL")}<br/>
                    <b>${this.point?.breakdownDimensionName}</b> : ${this.point?.series?.name}<br/>
                    <b>${this.point?.yAxisName == "Mention" ? "Volume of Conversation" : this.point?.yAxisName}</b>: ${numberWithCommas(this.y)}`;
                },
                // formatter: function () {
                //     if (plotComaprisiondata) {
                //         let str = "";
                //         let ComapareVal1;
                //         let ComapareVal2;
                //         let dateCompare;
                //         let showPercent = true;
                //         for (let i = 0; i < this.points.length; i++) {
                //             let temp = "";
                //             ComapareVal1 = this.points[0].y;
                //             ComapareVal2 = this.points[1]?.y;
                //             dateCompare = this.points[1]?.point.options.originalX > this.points[1]?.point.options.x;
                //             let firstColorPoint = this.points[1]?.color.endsWith("85");
                //             let secondColorPoint = this.points[0]?.color.endsWith("85");

                //             if ((firstColorPoint && secondColorPoint) || (!secondColorPoint && !firstColorPoint)) {
                //                 showPercent = false;
                //             }
                //             temp = `<b>${moment(this.points[i].point.originalX ? this.points[i].point.originalX : this.points[i].x)
                //                 .tz(tz)
                //                 .format(
                //                     "LLLL",
                //                 )}</b><br/><div style="margin-bottom:10px;"><span style="margin-right:10px;display:inline-block;width:8px;height:8px;background-color:${
                //                 this.points[i].color
                //             };border-radius:10px" ></span>

                //                 <b>${numberWithCommas(this.points[i].y)}</b> </div>`;

                //             str += temp;
                //         }

                //         if (this.points.length == 2 && showPercent) {
                //             str += `${
                //                 ComapareVal1 < ComapareVal2
                //                     ? `<div> <div style="display:flex;align-item:center"><b>${
                //                           ComapareVal1 !== 0 ? (((ComapareVal2 / ComapareVal1).toFixed(2) - 1) * 100).toFixed(2) + "%" : "NA"
                //                       }</b>

                //                     <img src=${dateCompare ? UpIcon : DownIcon} width="16px" height="16px" style="margin-left:5px;transform:${
                //                           dateCompare && "rotate(180deg)"
                //                       }" />
                //                     </div>

                //                     </div>`
                //                     : ComapareVal1 > ComapareVal2
                //                     ? `<div> <div style="display:flex;align-item:center"><b>${
                //                           ComapareVal2 !== 0 ? (((ComapareVal1 / ComapareVal2).toFixed(2) - 1) * 100).toFixed(2) + "%" : "NA"
                //                       }</b>

                //                         <img src=${dateCompare ? DownIcon : UpIcon} width="16px" height="16px" style="margin-left:5px;transform:${
                //                           !dateCompare && "rotate(180deg)"
                //                       }" />
                //                         </div>

                //                         </div>`
                //                     : ""
                //             }`;
                //         }

                //         return str;
                //     } else {
                //         return `${moment(this.x).tz(tz).format("LLLL")}<br/>${this.point?.series?.name}: <b>${numberWithCommas(this.y)}</b>`;
                //     }
                // },
                backgroundColor: "#fff",
                borderRadius: 6,
            },
        };

        return optionsOverTime;
    };
    getOneDimensionOneMetricLineOptions = () => {
        let self = this;
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let tzo = JSON.parse(localStorage.company).user_timezone * -60;

        let serObj = [];
        // this.props.csvData.lineData.data.forEach((ele) => {
        //     let obj = {};
        //     obj.x = ele.name;
        //     obj.y = ele.y;
        //     serObj.push(obj);
        // });
        serObj = this.props.csvData.lineData.data ? JSON.parse(JSON.stringify(this.props.csvData.lineData.data)) : this.props.csvData.lineData.data;
        serObj.forEach((obj) => {
            obj.x = obj.name;
            delete obj.name;
        });

        const optionsOverTime = {
            chart: {
                type: "spline",
                className: "skiptranslate",
                backgroundColor: "transparent",
                // spacingTop: 0,
                // spacingBottom: 0,
                // spacingLeft: 0,
                // spacingRight: 0,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            credits: {
                enabled: false,
            },
            title: {
                text: " ",
            },
            legend: {
                enabled: this.props.showLegend,
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M %p",
                    second: "%l:%M %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
                labels: {
                    style: {
                        textTransform: "normal",
                    },
                },
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: " ",
            },
            // series: serObj,
            series: [
                {
                    name: "Published Date",
                    data: serObj,
                },
            ],
            plotOptions: {
                series: {
                    marker: {
                        symbol: "circle",
                        radius: 4,
                    },
                    stickyTracking: false,
                    // events: {
                    //     legendItemClick: function () {
                    //         self.props.legendClick(true);
                    //     },
                    // },
                    // {
                    //     symbol: "triangle-down",
                    //     radius: 4,
                    // },
                    // ],
                },
                spline: {
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, Object.assign({}, this));
                            },
                        },
                    },
                },
            },
            time: {
                timezoneOffset: tzo,
            },
            tooltip: {
                followPointer: true,
                // followTouchMove: true,
                // outside: false,
                // crosshairs: true,
                useHTML: true,
                formatter: function () {
                    return `${moment(this.x).tz(tz).format("LLLL")}<br/><b>${this.point?.yAxisName}</b>: ${numberWithCommas(this.y)}`;
                },

                backgroundColor: "#fff",
                borderRadius: 6,
            },
        };

        return optionsOverTime;
    };
    getOneDimensionTwoMetricLineOptions = () => {
        let self = this;
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let tzo = JSON.parse(localStorage.company).user_timezone * -60;

        let leftArr = [];
        let rightArr = [];
        this.props.maximizeData.leftYAxis.data.forEach((ele) => {
            let obj = {};
            obj.x = ele.dataId;
            obj.y = ele.y;
            obj.dataId = ele.dataId;
            obj.dimensionName = ele.dimensionName;
            obj.metricName = ele.metricName;
            leftArr.push(obj);
        });
        this.props.maximizeData.rightYAxis.data.forEach((ele) => {
            let obj = {};
            obj.x = ele.dataId;
            obj.y = ele.y;
            obj.dataId = ele.dataId;
            obj.dimensionName = ele.dimensionName;
            obj.metricName = ele.metricName;
            rightArr.push(obj);
        });
        let serObj = [
            {
                name: this.props.data.leftYAxis.name,
                data: leftArr,
            },
            { name: this.props.data.rightYAxis.name, data: rightArr },
        ];

        const optionsOverTime = {
            chart: {
                type: "spline",
                className: "skiptranslate",
                backgroundColor: "transparent",
                // spacingTop: 0,
                // spacingBottom: 0,
                // spacingLeft: 0,
                // spacingRight: 0,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            credits: {
                enabled: false,
            },
            title: {
                text: " ",
            },
            legend: {
                enabled: this.props.showLegend,
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M %p",
                    second: "%l:%M %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
                labels: {
                    style: {
                        textTransform: "normal",
                    },
                },
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: " ",
            },
            // series: serObj,
            series: serObj,
            plotOptions: {
                series: {
                    marker: {
                        symbol: "circle",
                        radius: 4,
                    },
                    stickyTracking: false,
                    // events: {
                    //     legendItemClick: function () {
                    //         self.props.legendClick(true);
                    //     },
                    // },
                    // {
                    //     symbol: "triangle-down",
                    //     radius: 4,
                    // },
                    // ],
                },
                spline: {
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, Object.assign({}, this));
                            },
                        },
                    },
                },
            },
            time: {
                timezoneOffset: tzo,
            },
            tooltip: {
                followPointer: true,
                // followTouchMove: true,
                // outside: true,
                // crosshairs: true,
                useHTML: true,
                formatter: function () {
                    return `${moment(this.x).tz(tz).format("LLLL")}<br/><b>${this.point?.series?.name}</b>: ${numberWithCommas(this.y)}`;
                },
                backgroundColor: "#fff",
                borderRadius: 6,
            },
        };

        return optionsOverTime;
    };

    render() {
        let currentChartType = "stacked";
        if (this.props.widget.multiDimensionChartConfig.dimensionName?.label == "published_date") {
            currentChartType = this.props.currentChartType;
        }

        return (
            <>
                {this.props.data &&
                    currentChartType == "stacked" &&
                    this.props.data?.leftYAxis &&
                    this.props.widget.multiDimensionChartConfig.dimensionName?.label?.trim().length > 0 &&
                    this.props.widget.multiDimensionChartConfig.breakdownDimensionName?.label?.trim().length > 0 &&
                    this.props.widget.multiDimensionChartConfig.metricName?.label?.trim().length > 0 &&
                    this.props.widget.multiDimensionChartConfig.breakdownMetricName?.label?.trim().length > 0 && (
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getTwoDimensionTwoMetricBarOptions()}
                            ref={this.chartComponent}
                            containerProps={{ style: { width: "100%", height: "calc(100% - 0px)" } }}
                            immutable={true}
                        />
                    )}
                {this.props.data &&
                    currentChartType == "line" &&
                    this.props.data?.leftYAxis &&
                    this.props.widget.multiDimensionChartConfig.dimensionName?.label?.trim().length > 0 &&
                    this.props.widget.multiDimensionChartConfig.breakdownDimensionName?.label?.trim().length > 0 &&
                    this.props.widget.multiDimensionChartConfig.metricName?.label?.trim().length > 0 &&
                    this.props.widget.multiDimensionChartConfig.breakdownMetricName?.label?.trim().length > 0 && (
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getTwoDimensionTwoMetricLineOptions()}
                            ref={this.chartComponent}
                            containerProps={{ style: { width: "100%", height: "calc(100% - 0px)" } }}
                            immutable={true}
                        />
                    )}

                {this.props.data &&
                    currentChartType == "stacked" &&
                    this.props.widget.multiDimensionChartConfig.dimensionName?.label?.trim().length > 0 &&
                    this.props.widget.multiDimensionChartConfig.breakdownDimensionName?.label?.trim().length > 0 &&
                    this.props.widget.multiDimensionChartConfig.metricName?.label?.trim().length > 0 &&
                    this.props.widget.multiDimensionChartConfig.breakdownMetricName == "" && (
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getTwoDimensionOneMetricBarOptions()}
                            ref={this.chartComponent}
                            containerProps={{ style: { width: "100%", height: "calc(100% - 0px)" } }}
                            immutable={true}
                        />
                    )}

                {this.props.data &&
                    currentChartType == "line" &&
                    this.props.widget.multiDimensionChartConfig.dimensionName?.label?.trim().length > 0 &&
                    this.props.widget.multiDimensionChartConfig.breakdownDimensionName?.label?.trim().length > 0 &&
                    this.props.widget.multiDimensionChartConfig.metricName?.label?.trim().length > 0 &&
                    this.props.widget.multiDimensionChartConfig.breakdownMetricName == "" && (
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getTwoDimensionOneMetricLineOptions()}
                            ref={this.chartComponent}
                            containerProps={{ style: { width: "100%", height: "calc(100% - 0px)" } }}
                            immutable={true}
                        />
                    )}

                {this.props.data &&
                    currentChartType == "stacked" &&
                    this.props.data?.leftYAxis &&
                    this.props.widget.multiDimensionChartConfig.dimensionName?.label?.trim().length > 0 &&
                    this.props.widget.multiDimensionChartConfig.metricName?.label?.trim().length > 0 &&
                    this.props.widget.multiDimensionChartConfig.breakdownDimensionName == "" &&
                    this.props.widget.multiDimensionChartConfig.breakdownMetricName?.label?.trim().length > 0 && (
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getOneDimensionTwoMetricBarOptions()}
                            ref={this.chartComponent}
                            containerProps={{ style: { width: "100%", height: "calc(100% - 0px)" } }}
                            immutable={true}
                        />
                    )}
                {this.props.data &&
                    currentChartType == "line" &&
                    this.props.data?.leftYAxis &&
                    this.props.widget.multiDimensionChartConfig.dimensionName?.label?.trim().length > 0 &&
                    this.props.widget.multiDimensionChartConfig.metricName?.label?.trim().length > 0 &&
                    this.props.widget.multiDimensionChartConfig.breakdownDimensionName == "" &&
                    this.props.widget.multiDimensionChartConfig.breakdownMetricName?.label?.trim().length > 0 && (
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getOneDimensionTwoMetricLineOptions()}
                            ref={this.chartComponent}
                            containerProps={{ style: { width: "100%", height: "calc(100% - 0px)" } }}
                            immutable={true}
                        />
                    )}

                {this.props.data &&
                    currentChartType !== "line" &&
                    this.props.widget.multiDimensionChartConfig.dimensionName?.label?.trim().length > 0 &&
                    this.props.widget.multiDimensionChartConfig.metricName?.label?.trim().length > 0 &&
                    this.props.widget.multiDimensionChartConfig.breakdownDimensionName == "" &&
                    this.props.widget.multiDimensionChartConfig.breakdownMetricName == "" && (
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getOneDimensionOneMetric()}
                            ref={this.chartComponent}
                            containerProps={{ style: { width: "100%", height: "calc(100% - 0px)" } }}
                            immutable={true}
                        />
                    )}
                {this.props.data &&
                    currentChartType == "line" &&
                    this.props.widget.multiDimensionChartConfig.dimensionName?.label?.trim().length > 0 &&
                    this.props.widget.multiDimensionChartConfig.metricName?.label?.trim().length > 0 &&
                    this.props.widget.multiDimensionChartConfig.breakdownDimensionName == "" &&
                    this.props.widget.multiDimensionChartConfig.breakdownMetricName == "" && (
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getOneDimensionOneMetricLineOptions()}
                            ref={this.chartComponent}
                            containerProps={{ style: { width: "100%", height: "calc(100% - 0px)" } }}
                            immutable={true}
                        />
                    )}
            </>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        multiDimensionChartConfig: state.advCustomChartReducer.multiDimensionChartConfig,
    };
};
export default connect(mapStateToProps)(AdvanceCustomChartDisplay);
